import { axiosGet, axiosPost } from "../../../../react_axios/Axios";
import { headers, getLiquorLicenseMasterListUrl, insertUpdateLiquorLicenseMasterUrl, DELETE_LIQUOR_LICENSE_MASTER, deleteLiquorLicenseMasterUrl, GET_LIQUOR_LICENSE_MASTER_LIST, INSERT_UPDATE_LIQUOR_LICENSE_MASTER } from "../../../../utils/constants";


export const insertUpdateLiquorLicenseMaster_action = (LLList) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            LLList: LLList
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosPost(insertUpdateLiquorLicenseMasterUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_LIQUOR_LICENSE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getLiquorLicenseMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        }
        console.log("getVisaInvitation_action Action------->", params)

        const res = await axiosGet(getLiquorLicenseMasterListUrl, params, headers)

        dispatch({
            type: GET_LIQUOR_LICENSE_MASTER_LIST,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteLiquorLicenseMaster_action = (deleteId) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            LiquorLicenseContactPersonID: deleteId
        }
        console.log("deleteExhibitionDocument_action Action------->", params)

        const res = await axiosGet(deleteLiquorLicenseMasterUrl, params, headers)

        dispatch({
            type: DELETE_LIQUOR_LICENSE_MASTER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}